angular.module('app').controller('CouponCtrl', function($controller, $scope, $mdToast) {
    "ngInject";

    var main = this;

    main.name = 'coupon';
    main.defaults = {
        'config': {
            'product_restrictions': false,
            'event_restrictions': false,
            'events': [],
            'products': []
        }
    };

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.addProduct = function() {
        if(!main.productToAdd) {
            return;
        }

        main.item.config.products.push(main.productToAdd);
        main.productToAdd = null;
    };

    main.save = function() {
        main._save().then(
            null,
            function(response) {
                if(response.data.message == 'IntegrityError') {
                    var alert = $mdToast.simple().textContent('A coupon with this code already exists');
                    $mdToast.show(alert);
                }
            }
        );
    };

    main.addEvent = function() {
        if(!main.eventToAdd) {
            return;
        }

        main.item.events.push({'id': main.eventToAdd.id, 'name': main.eventToAdd.name});
        main.eventToAdd = null;
    };
});
